!(function () {
  'use strict';

  const SCROLL_SPY_SELECTOR = '[data-scroll-spy]';
  const ACTIVE_CLASS = 'is-selected';
  const CONTAINER_ATTR = 'data-scroll-spy-container';
  const SPY_ATTR = 'data-scroll-spy';
  const MOBILE_ATTR = 'data-scroll-spy-mobile';
  const DESKTOP_ATTR = 'data-scroll-spy-desktop';
  const TRIGGER_POINT_ATTR = 'data-scroll-trigger-point';

  if (!customElements.get('scroll-spy')) {
    customElements.define('scroll-spy', class extends HTMLElement {
      constructor() {
        super();
        
        this.container = this?.closest(this?.getAttribute(CONTAINER_ATTR)) || document;
        this.scrollSpyButton = this.querySelector(SCROLL_SPY_SELECTOR);
        this.elementToSpy = this.container.querySelector(this.scrollSpyButton.getAttribute(SPY_ATTR));
        this.anchorSelector = `[${SPY_ATTR}="#${this.elementToSpy.id}"]`;
        this.anchor = this.container.querySelector(this.anchorSelector);
        this.anchorSiblings = this.container.querySelectorAll(`[${SPY_ATTR}]`);
        this.initialized = false;

        if (this.anchor) {
          this.triggerPoint = this.anchor.getAttribute(TRIGGER_POINT_ATTR);
          this.scrollCallback = () => this.onScroll();
          this.toggleScrollObserver = this.toggleScrollObserver.bind(this);
        }
      }

      connectedCallback() {
        this.toggleScrollObserver();
        document.addEventListener('theme:resize:width', this.toggleScrollObserver);
      }

      toggleScrollObserver() {
        if (this.isEligible()) {
          if (!this.initialized) {
            document.addEventListener('theme:scroll', this.scrollCallback);
            this.initialized = true;
          }
        } else {
          document.removeEventListener('theme:scroll', this.scrollCallback);
          this.initialized = false;
        }
      }

      isEligible() {
        const isDesktop = !window.theme.isMobile();
        
        if (!isDesktop && this.anchor.hasAttribute(MOBILE_ATTR)) return true;
        if (isDesktop && this.anchor.hasAttribute(DESKTOP_ATTR)) return true;
        if (!this.anchor.hasAttribute(DESKTOP_ATTR) && !this.anchor.hasAttribute(MOBILE_ATTR)) return true;
        
        return false;
      }

      getStickyHeaderOffset() {
        const stickyHeader = document.querySelector('[data-header-sticky]');
        const headerElement = document.querySelector('[data-header-height]');
        
        if (stickyHeader && headerElement) {
          return headerElement.offsetHeight;
        }
        
        // Fallback: check for stuck header class
        const stuckHeader = document.querySelector('.js__header__stuck');
        if (stuckHeader) {
          return stuckHeader.offsetHeight;
        }
        
        return 0;
      }

      onScroll() {
        this.top = this.elementToSpy.getBoundingClientRect().top;
        
        const windowHeight = Math.round(window.innerHeight);
        const scrollY = Math.round(window.scrollY);
        const viewportBottom = scrollY + windowHeight;
        const elementTop = Math.round(this.top + scrollY);
        const elementHeight = this.elementToSpy.offsetHeight;

        // Check if element is visible in viewport
        const elementInView = elementTop < viewportBottom && !(elementTop + elementHeight < scrollY);
        
        if (elementInView && this.triggerPointReached()) {
          // Remove active class from siblings
          this.anchorSiblings.forEach((anchor) => {
            if (!anchor.matches(this.anchorSelector)) {
              anchor.classList.remove(ACTIVE_CLASS);
            }
          });
          
          // Add active class to current anchor
          this.anchor.classList.add(ACTIVE_CLASS);
        }
      }

      triggerPointReached() {
        const stickyHeaderOffset = this.getStickyHeaderOffset();
        let reached = false;

        switch (this.triggerPoint) {
          case 'top':
          default:
            // Account for sticky header - element should be considered "at top" when it hits the sticky header
            reached = this.top <= stickyHeaderOffset;
            break;
          case 'middle':
            // Account for sticky header in middle calculation
            reached = this.top <= (window.innerHeight / 2) - (stickyHeaderOffset / 2);
            break;
          case 'bottom':
            // Account for sticky header in bottom calculation  
            reached = this.top <= window.innerHeight - stickyHeaderOffset;
            break;
        }

        return reached;
      }

      disconnectedCallback() {
        document.removeEventListener('theme:resize:width', this.toggleScrollObserver);
        document.removeEventListener('theme:scroll', this.scrollCallback);
      }
    });
  }
})();
